<!--
 * @Description: 
 * @Author: 
 * @Date: 2023-08-28 19:28:13
 * @LastEditTime: 2025-09-28 17:16:36
 * @LastEditors: dongqianqian
 * @Usage: 
-->
<template>
  <div>
    <HeadTop />
    <div class="conBG">
      <ul class="menuList">
        <li
          v-for="(item,index) in list"
          :key="item.id"
          :class="{'active':navIndex==index}"
          @click="navIndex=index; to(item)"
        >
          {{item.name}}</li>
        <div style="clear:both;"></div>
      </ul>
      <router-view />
    </div>
  </div>
</template>

<script>
import HeadTop from '@/components/header.vue'
export default {
  data() {
    return {
      navIndex: 0,
      list: [
        {
          id: 'projectmanager',
          name: '工程管理'
        },
        {
          id: 'projectinfo',
          name: '参建单位管理'
        },
        {
          id: 'projectdepart',
          name: '部门管理'
        },
        {
          id: 'projectrole',
          name: '角色管理'
        },
        {
          id: 'projectpreson',
          name: '人员管理'
        },
        {
          id: 'projectsetting',
          name: '配置管理'
        },
        {
          id: 'projectwarnSetting',
          name: '后台管理'
        },
      ],
    }
  },
  components: {
    HeadTop
  },
  created() {
    // 根据当前路由设置正确的navIndex
    this.setNavIndexFromRoute();
  },
  watch: {
    // 监听路由变化，更新navIndex
    '$route'() {
      this.setNavIndexFromRoute();
    }
  },
  methods: {
    setNavIndexFromRoute() {
      console.log(this.$route);
      
      const currentRouteName = this.$route.name;
      const index = this.list.findIndex(item => item.id === currentRouteName);
      if (index !== -1) {
        this.navIndex = index;
      }
    },
    to(v) {
      this.$router.push({
        name: v.id
      })
    }
  }
}
</script>

<style>
</style>